import React from 'react'

import MaskedView from '@react-native-masked-view/masked-view'
import { H2 } from '@zet/design-system'
import { LinearGradient } from 'expo-linear-gradient'

const GradientText = ({ ...props }) => {
  return (
    <MaskedView maskElement={<H2 {...props} />}>
      <LinearGradient
        colors={['#FFEACE', '#F4BB71']}
        start={[0, 0]}
        end={[1, 0.0]}
        locations={[0.0, 0.41]}
      >
        <H2 className="mt-1" {...props} style={[props.style, { opacity: 0 }]} />
      </LinearGradient>
    </MaskedView>
  )
}

export default GradientText
